WatchSumo.Graph = class Graph {
  constructor(element, json_path) {
    this.element = element;
    this.json_path = json_path;
    
    $.getJSON(json_path, (data) => {
      this.data = data;
      this.graph = this.render();
    });
  }
};